var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "account" }, [
    _c(
      "div",
      { staticClass: "account-cards" },
      [
        _c(
          "div",
          { staticClass: "account-cards__item" },
          [
            _c("div", { staticClass: "account__heading" }, [
              _vm._v(" " + _vm._s(_vm.$t(`account.edit.acountData`)) + " ")
            ]),
            _c("CardLogo", {
              attrs: { "client-data": _vm.clientData },
              on: { "update-logo": data => _vm.$emit("update-logo", data) }
            }),
            _c("CardCompany", {
              attrs: { "client-data": _vm.clientData },
              on: { "update-client": data => _vm.$emit("update-client", data) }
            })
          ],
          1
        ),
        _c("CardPlans", {
          directives: [
            {
              name: "profile-guard",
              rawName: "v-profile-guard",
              value: "components.plan.subscription.read",
              expression: "'components.plan.subscription.read'"
            }
          ]
        }),
        _c("CardSubscription")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }